exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".address-fields-container .select-field-container{text-align:left}.address-fields-container .select-field-container .label-wrapper label{color:#acacac !important}\n", ""]);

